import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/in-love.svg'
import _imports_1 from '@/assets/svg/excited.svg'
import _imports_2 from '@/assets/5-stars.svg'


const _withScopeId = n => (_pushScopeId("data-v-c3ba2c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "review" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" class=\"love\" width=\"240\" height=\"240\" alt=\"\" data-v-c3ba2c8a><img src=\"" + _imports_1 + "\" class=\"excited\" width=\"240\" height=\"240\" alt=\"\" data-v-c3ba2c8a><div class=\"review__text\" data-v-c3ba2c8a><p data-v-c3ba2c8a>99% Customer Satisfaction.</p><h4 data-v-c3ba2c8a>They trust Butler. But why?</h4></div><button class=\"review__stars\" data-v-c3ba2c8a><p data-v-c3ba2c8a>Google Ratings</p><img src=\"" + _imports_2 + "\" alt=\"google ratings\" data-v-c3ba2c8a></button>", 4)
const _hoisted_6 = { class: "review__marquee" }
const _hoisted_7 = { class: "review__marquee__container" }
const _hoisted_8 = { class: "scroll" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "item__text" }
const _hoisted_11 = { class: "item__text__top" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "item__text" }
const _hoisted_14 = { class: "item__text__top" }
const _hoisted_15 = { class: "review__marquee" }
const _hoisted_16 = { class: "review__marquee__container two" }
const _hoisted_17 = { class: "scroll" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "item__text" }
const _hoisted_20 = { class: "item__text__top" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "item__text" }
const _hoisted_23 = { class: "item__text__top" }


export default /*#__PURE__*/_defineComponent({
  __name: 'Review',
  setup(__props) {

const reviews: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  title: string;
  role: string;
  comment: string;
  bg: string;
  textcolor: string;
  textcolor2: string;
}[] = [
  {
    icon: require("@/assets/user.png"),
    title: "Moses Adebayo",
    role: "Creative Director",
    comment:
      "Lorem ipsum dolor sit amet consectetur. Aenean nibh gravida convallis cursus varius a. Amet sagittis at diam interdum.",
    bg: "#1F3138",
    textcolor: "#D6EEE9",
    textcolor2: "#FFFFFF",
  },
  {
    icon: require("@/assets/user.png"),
    title: "Niles James",
    role: "Frontend Developer",
    comment:
      "Lorem ipsum dolor sit amet consectetur. Aenean nibh gravida convallis cursus varius a. Amet sagittis at diam interdum. ",
    bg: "#51DA7F",
    textcolor: "#1F3138",
    textcolor2: "#1F3138",
  },
  {
    icon: require("@/assets/user.png"),
    title: "Moses Adebayo",
    role: "Creative Director",
    comment:
      "Lorem ipsum dolor sit amet consectetur. Aenean nibh gravida convallis cursus varius a. Amet sagittis at diam interdum.",
    bg: "#1F3138",
    textcolor: "#D6EEE9",
    textcolor2: "#FFFFFF",
  },
  {
    icon: require("@/assets/user.png"),
    title: "Niles James",
    role: "Frontend Developer",
    comment:
      "Lorem ipsum dolor sit amet consectetur. Aenean nibh gravida convallis cursus varius a. Amet sagittis at diam interdum. ",
    bg: "#8E3AE2",
    textcolor: "#D6EEE9",
    textcolor2: "#FFFFFF",
  },
  {
    icon: require("@/assets/user.png"),
    title: "Moses Adebayo",
    role: "Creative Director",
    comment:
      "Lorem ipsum dolor sit amet consectetur. Aenean nibh gravida convallis cursus varius a. Amet sagittis at diam interdum.",
    bg: "#071012",
    textcolor: "#D6EEE9",
    textcolor2: "#FFFFFF",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (item, index) => {
            return _createElementVNode("div", {
              class: "item",
              key: index,
              style: _normalizeStyle({ backgroundColor: item.bg })
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: "user icon",
                width: "69",
                height: "69"
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h6", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.title), 5),
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.role), 5)
                ]),
                _createElementVNode("h5", {
                  style: _normalizeStyle({ color: item.textcolor2 })
                }, _toDisplayString(item.comment), 5)
              ])
            ], 4)
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (item, index) => {
            return _createElementVNode("div", {
              class: "item",
              key: index,
              style: _normalizeStyle({ backgroundColor: item.bg })
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: "user icon",
                width: "69",
                height: "69"
              }, null, 8, _hoisted_12),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h6", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.title), 5),
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.role), 5)
                ]),
                _createElementVNode("h5", {
                  style: _normalizeStyle({ color: item.textcolor2 })
                }, _toDisplayString(item.comment), 5)
              ])
            ], 4)
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (item, index) => {
            return _createElementVNode("div", {
              class: "item",
              key: index,
              style: _normalizeStyle({ backgroundColor: item.bg })
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: "user icon",
                width: "69",
                height: "69"
              }, null, 8, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h6", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.title), 5),
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.role), 5)
                ]),
                _createElementVNode("h5", {
                  style: _normalizeStyle({ color: item.textcolor2 })
                }, _toDisplayString(item.comment), 5)
              ])
            ], 4)
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(reviews, (item, index) => {
            return _createElementVNode("div", {
              class: "item",
              key: index,
              style: _normalizeStyle({ backgroundColor: item.bg })
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: "user icon",
                width: "69",
                height: "69"
              }, null, 8, _hoisted_21),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h6", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.title), 5),
                  _createElementVNode("p", {
                    style: _normalizeStyle({ color: item.textcolor })
                  }, _toDisplayString(item.role), 5)
                ]),
                _createElementVNode("h5", {
                  style: _normalizeStyle({ color: item.textcolor2 })
                }, _toDisplayString(item.comment), 5)
              ])
            ], 4)
          }), 64))
        ])
      ])
    ])
  ]))
}
}

})